// noinspection JSValidateTypes

import {Basic} from "./Basic";
import {Load} from "./Load";
import {Modal} from "./Modal";
import {History} from "./History";

export class Payment
{
    constructor(option)
    {
        this.paymentOption = option ? option : '';
    }

    static insert_payPal()
    {
        const payPalPlaceholder = document.getElementById("w--ppplus");
        if(payPalPlaceholder)
        {
            const myModal = new Modal('PayPal wird initialisiert ...'),
                payPal = document.createElement('script');
            payPal.setAttribute('defer', '');
            payPal.src = 'https://www.paypalobjects.com/webstatic/ppplus/ppplus.min.js';
            payPal.addEventListener('load',() =>
            {
                const ppp = PAYPAL.apps.PPP({
                    approvalUrl: payPalPlaceholder.dataset.approvalUrl,
                    placeholder: 'w--ppplus',
                    mode: payPalPlaceholder.dataset.paypalMode,
                    country: 'DE',
                    language: 'de',
                    onLoad: () =>
                    {
                        myModal.remove()
                    }
                });
            });
            document.body.appendChild(payPal);
        }
    }

    process(action, el)
    {
        if(action === 'build')
        {
            new Modal('Zahloptionen werden geladen ...');
            document.location = Basic.base + 'shop/payment';
        }
        else
        {
            const data = {
                f: 'payment',
                action: action,
                paymentOption: this.paymentOption
            };

            if(action === 'confirm' && el)
            {
                data.tempOrderId = parseInt(el.dataset.tempOrderId);
                data.verify = el.dataset.verify;
            }

            const message = new Modal(
                (action === 'confirm' || action === 'finalize-order')
                    ? 'Bitte warten, Ihre Bestellung wird verarbeitet ...'
                    : 'Eingabe wird verarbeitet ...');

            Load.post('shop/payment',data).then(r =>
            {
                switch(action)
                {
                    case 'confirm':
                    case 'finalize-order':
                        message.remove();
                        document.getElementById('w--main').innerHTML = r['html'];
                        document.title = r['pageTitle'].replace('&amp;', '&');
                        document.documentElement.scrollTo(0,0);
                        History.push_url(Basic.base + 'shop/complete', r['pageTitle']);
                        Basic.cart.cartExtras = {};
                        localStorage.removeItem("extras");
                        Basic.cart.cartItems = [];
                        localStorage.removeItem("cart");
                        Basic.delivery.pickup = {};
                        sessionStorage.removeItem("pickup");
                        Basic.cart.update_cartIcon();
                        break;

                    case 'set-payment':
                        document.location = Basic.base + 'shop/payment';
                        break;
                }
            }).catch(error =>
            {
                message.remove();
                new Modal(error['error_message']
                                ? error['error_message']
                                : 'Ihre Eingabe konnte nicht verarbeitet werden.',
                          true);
            });
        }
    }

    set_submitButton(status)
    {
        if(status !== undefined)
        {
            const submitButton = document.body.querySelector('.w__shop--buttons .w__button--submit');
            if(submitButton)
            {
                (status === true)
                    ? submitButton.classList.remove('inactive')
                    : submitButton.classList.add('inactive')
            }
        }
    }
}